import React, { useState } from 'react';
import './Page.css';
import ContactModal from '../components/ContactModal';

const Enzymes = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const enzymeService = {
    id: 'enzyme-treatments',
    title: 'Septic Enzymes & Treatments',
    customMessage: 'I am interested in learning more about septic enzyme treatments from All Around Septic Pumping, LLC.\n\nPlease provide me with more information about your enzyme products, how they work, and pricing.'
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Septic Enzymes & Treatments</h1>
        <p className="page-subtitle">Natural solutions for septic system health</p>
      </div>

      <div className="content-section">
        <div className="enzymes-info">
          <div className="info-card">
            <h3>Why Use Enzymes?</h3>
            <p>
              Septic enzymes help break down organic waste naturally, improving the efficiency 
              of your septic system and reducing the need for frequent pumping.
            </p>
          </div>

          <div className="info-card">
            <h3>Our Products</h3>
            <p>
              We offer high-quality enzyme treatments designed to maintain and improve your 
              septic system's performance. Our products are safe, effective, and environmentally friendly.
            </p>
          </div>

          <div className="info-card">
            <h3>Benefits</h3>
            <ul className="benefits-list">
              <li>Reduces odors</li>
              <li>Breaks down waste more efficiently</li>
              <li>Extends time between pumpings</li>
              <li>Safe for your system and the environment</li>
              <li>Easy to use</li>
            </ul>
          </div>
        </div>

        <div className="cta-section">
          <h2>Interested in Enzyme Treatments?</h2>
          <p>Contact us to learn more about our enzyme products and how they can benefit your septic system.</p>
          <button onClick={openModal} className="cta-button">Get in Touch</button>
        </div>
      </div>

      {isModalOpen && (
        <ContactModal
          service={enzymeService}
          onClose={closeModal}
        />
      )}
    </div>
  );
};

export default Enzymes;

